import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { screenHeightLeftFromTop } from "Constants";
import LocaleStrings from "Languages";
import AttendeesmessagingMenuIcon from "./attendeesmessaging-menu-icon";
import AttendeesmessagingEngmntChart from "./attendeesmessaging-engmnt-chart";
import AnalyticsCommonHeader from "AnalyticscommonAnalyticscommon";

import { attendeesmessagingsentmsgcount } from "AttendeesmessagingSentmsgAction";
import {
  attendeesmessagingcommunicationcount,
  attendeesmessagingMsgengmntbarchart,
} from "AttendeesmessagingCommunicationAction"; // Getting getdata count fc from actions
import { attendeesmessagingrecemsgcount } from "AttendeesmessagingRecemsgAction"; // Getting getdata count fc from actions
import { attendeesmessagingmsgthreadcount } from "AttendeesmessagingMsgthreadAction"; // Getting getdata count fc from actions

import { attendeesnetworkmsgsentcount } from "AttendeesnetworkMsgsentAction";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class AttendeesmessagingInside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.analytics_text_preparing_analytics,
      loader: false,
    };
  }

  //
  componentDidMount() {
    this.props.attendeesnetworkmsgsentcount(
      this.props.session,
      (attendeesnetworkmsgsentresponse) => {
        if (attendeesnetworkmsgsentresponse.error === 0) {
        }
      }
    );

    this.props.attendeesmessagingsentmsgcount(
      this.props.session,
      (attendeesmessagingsentmsgresponse) => {
        if (attendeesmessagingsentmsgresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.attendeesmessagingcommunicationcount(
      this.props.session,
      (attendeesmessagingcommunicationresponse) => {
        if (attendeesmessagingcommunicationresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.attendeesmessagingrecemsgcount(
      this.props.session,
      (attendeesmessagingrecemsgresponse) => {
        if (attendeesmessagingrecemsgresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.attendeesmessagingmsgthreadcount(
      this.props.session,
      (attendeesmessagingmsgthreadresponse) => {
        if (attendeesmessagingmsgthreadresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    //Call to Messaging Engagement (Chart view of how attendees communicated over the selected date range)
    this.props.attendeesmessagingMsgengmntbarchart(
      this.props.session,
      this.props.datePropsMainPg,
      (attendeesmessagingmsgengmntbarchartResponse) => {
        if (attendeesmessagingmsgengmntbarchartResponse.error === 0) {
          this.setState({ loading: false });
        }
      }
    );
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  // Arrow function for render Attendees Messaging menu divs
  rebderAttendeesmessagingMenuIcons() {
    return _.map(
      this.props.attendeesMessagingMenu,
      (attendeesmessagingmenuItem) => {
        return (
          <AttendeesmessagingMenuIcon
            menu={attendeesmessagingmenuItem}
            key={attendeesmessagingmenuItem.key}
          />
        );
      }
    );
  }

  // Send function with props for barchartdate change
  onDateChartChangeFc(obj) {
    this.setState({ loader: !this.state.loader });
  }

  // Rerender All componets on this page
  mainCallback = () => {
    this.setState({ loading: true });

    this.props.attendeesnetworkmsgsentcount(
      this.props.session,
      (attendeesnetworkmsgsentresponse) => {
        if (attendeesnetworkmsgsentresponse.error === 0) {
        }
      }
    );

    this.props.attendeesmessagingsentmsgcount(
      this.props.session,
      (attendeesmessagingsentmsgresponse) => {
        if (attendeesmessagingsentmsgresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.attendeesmessagingcommunicationcount(
      this.props.session,
      (attendeesmessagingcommunicationresponse) => {
        if (attendeesmessagingcommunicationresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.attendeesmessagingrecemsgcount(
      this.props.session,
      (attendeesmessagingrecemsgresponse) => {
        if (attendeesmessagingrecemsgresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.attendeesmessagingmsgthreadcount(
      this.props.session,
      (attendeesmessagingmsgthreadresponse) => {
        if (attendeesmessagingmsgthreadresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    //Call to Messaging Engagement (Chart view of how attendees communicated over the selected date range)
    this.props.attendeesmessagingMsgengmntbarchart(
      this.props.session,
      this.props.datePropsMainPg,
      (attendeesmessagingmsgengmntbarchartResponse) => {
        if (attendeesmessagingmsgengmntbarchartResponse.error === 0) {
          this.setState({ loading: false });
        }
      }
    );
  };

  render() {
    let { deviceSize } = this.props;

    return (
      <div className="panel noborder-panel">
        {/* Header section */}
        {!this.state.loading ? (
          <AnalyticsCommonHeader
            finishOperationsCallback={this.mainCallback}
            callFrom="Attendees Messaging"
            xchart={this.onDateChartChangeFc.bind(this)}
          />
        ) : (
          ""
        )}

        <div
          className="panel-body scrollable-content"
          style={{
            height: deviceSize.height - screenHeightLeftFromTop,
          }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <div>
              <ul className="nav nav-pills dashboardNavPill">
                {this.rebderAttendeesmessagingMenuIcons()}
              </ul>
              <div className="mt-20"></div>

              <div className="panel-body ">
                {this.props.attndsmsgngengadata ? (
                  <AttendeesmessagingEngmntChart
                    attndsmsgngengadata={this.props.attndsmsgngengadata}
                    newprop={this.state.loader}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var {
    session,
    user,
    attendeesMessagingMenu,
    attendeesmessagingSelectedItem,
  } = state;

  var totalsentmsg = state.attendeesmessagingTotalSentmsg
    ? state.attendeesmessagingTotalSentmsg
    : [];
  var totalcomm = state.attendeesmessagingTotalCommunication
    ? state.attendeesmessagingTotalCommunication
    : [];
  var totalrecemsg = state.attendeesmessagingTotalRecemsg
    ? state.attendeesmessagingTotalRecemsg
    : [];
  var totalmsgthread = state.attendeesmessagingTotalMsgthread
    ? state.attendeesmessagingTotalMsgthread
    : [];
  var attndsmsgngengadata = state.attendeesmessagingEngagementChart
    ? state.attendeesmessagingEngagementChart.response
    : [];
  var datePropsMainPg = state.analyticscommondatepropsreducer;

  return {
    session,
    user,
    attendeesMessagingMenu,
    attendeesmessagingSelectedItem,
    deviceSize: state.deviceSize,
    totalsentmsg,
    totalcomm,
    totalrecemsg,
    totalmsgthread,
    attndsmsgngengadata,
    datePropsMainPg,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  attendeesmessagingsentmsgcount,
  attendeesmessagingcommunicationcount,
  attendeesmessagingrecemsgcount,
  attendeesmessagingmsgthreadcount,
  attendeesmessagingMsgengmntbarchart,
  attendeesnetworkmsgsentcount,
})(AttendeesmessagingInside);
